import {useQuery} from "@apollo/client";
import {GET_EVENTS} from "../../server/graphql/queries";
import {ErrorBoundary} from "react-error-boundary";
import ErrorFallback from "../../components/ErrorFallback";
import {Carousel} from "../../components/Carousel";
import Slide from "./Slide";
import Loading from "../../components/Loading";

const FourLatestEvents = ({ events, loading, error }) => {
  if (loading) {
    return <Loading loading={loading} />;
  }
  else if (error) {
    throw new Error('Error fetching events, please contact us and try again later.')
  }
  else {
    if (events.length === 0) {
      return (
        <div className="text-center m-4 text-zinc-500">
          <h5 className="text-lg mb-2">There are no events at this time</h5>
          <p>Visit us <a href="https://ccing.org" target="_blank" className="text-artfulRed hover:underline">here</a> to know what we are up to</p>
        </div>
      )
    }
    else {
      return (
        <Carousel>
          {events.slice(0,4).map((event) => {
            return <Slide key={event.uuid} event={event} />;
          })}
        </Carousel>
      )
    }
  }
}

const EventsSlideShow = () => {
  const { loading, error, data, refetch } = useQuery(GET_EVENTS);
  const events = data?.events || [];

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => refetch()}
      resetKeys={[events]}>
      <FourLatestEvents
        events={events}
        loading={loading}
        error={error}
      />
    </ErrorBoundary>
  );
};

export default EventsSlideShow;
